import { makeAnalyticsAction, } from '../analytics/analytics-utils.js';
import { SearchPageEvents } from '../analytics/search-action-cause.js';
//TODO: KIT-2859
export const logQuerySuggestionClick = (payload) => makeAnalyticsAction('analytics/querySuggest', (client, state) => {
    const metadata = buildOmniboxSuggestionMetadata(state, payload);
    return client.makeOmniboxAnalytics(metadata);
});
export const omniboxAnalytics = () => ({
    actionCause: SearchPageEvents.omniboxAnalytics,
});
export function buildOmniboxSuggestionMetadata(state, payload) {
    const { id, suggestion } = payload;
    const querySuggest = state.querySuggest?.[id];
    if (!querySuggest) {
        throw new Error(`Unable to determine the query suggest analytics metadata to send because no query suggest with id "${id}" was found. Please check the sent #id.`);
    }
    const suggestions = querySuggest.completions.map((completion) => completion.expression);
    const lastIndex = querySuggest.partialQueries.length - 1;
    const partialQuery = querySuggest.partialQueries[lastIndex] || '';
    const querySuggestResponseId = querySuggest.responseId;
    return {
        suggestionRanking: suggestions.indexOf(suggestion),
        partialQuery,
        partialQueries: querySuggest.partialQueries,
        suggestions,
        querySuggestResponseId,
    };
}
